<template>
  <div>
    <!--    {{autherList}}-->
    <div v-if="detailsData.data" class="Publisher">
      <div class="title">发布者</div>
      <div @click="goBkOrBj" class="logo">
        <img
          v-if="autherInfo.headImg"
          v-lazy="`${$global.imgUrl}${autherInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ autherInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div
          class="listItem"
          v-if="detailsData.data && detailsData.data.userType === 1"
        >
          <div v-if="autherInfo.foundedDate" class="time">
            {{ autherInfo.foundedDate }}
          </div>
          <div class="time" v-else>--</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div
          class="listItem"
          v-if="detailsData.data && detailsData.data.userType !== 1"
        >
          <div class="time">{{ timeData.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType !== 1"
          class="listItem"
        >
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ timeData.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div v-if="detailsData.data" class="Publisher">
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <img
          v-if="periodicalInfo.headImg"
          v-lazy="`${$global.imgUrl}${periodicalInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div v-if="periodicalInfo.foundedDate" class="time">
            {{ periodicalInfo.foundedDate }}
          </div>
          <div class="time" v-else>--</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div class="listItem">
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div class="listItem">
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div v-if="autherList" class="author">
      <div class="title">作者</div>
      <div class="user">
        <!--        {{// autherList}}-->
        <div v-for="(item, i) in autherview" :key="i" class="userImg">
          <template>
            <img
              v-if="item.headImg"
              @click="goto(item)"
              class="img"
              v-lazy="`${$global.imgUrl}${item.headImg}`"
              alt=""
            />
            <div
              @click="goto(item)"
              v-else
              style="
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background: #007fff;
                color: white;
                text-align: center;
                display: inline-block;
                line-height: 60px;
                cursor: pointer;
              "
            >
              {{ item.realName.substring(item.realName.length - 2) }}
            </div>
            <div @click="goto(item)" class="name">{{ item.realName }}</div>
            <div class="shunxu">
              {{
                item.userId === detailsData.data.firstAuthorId
                  ? "第一作者"
                  : item.userId === detailsData.data.communicationAuthorId
                  ? "通讯作者"
                  : "其他作者"
              }}
            </div>
          </template>
        </div>
      </div>
      <div class="dian">
        <!--        {{allPage}}-->
        <div v-for="(item, i) in allPage" :key="i">
          <span
            style="cursor: pointer"
            @click="setIndex(i)"
            :class="i == index ? 'act' : ''"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "right",
  props: [
    "type",
    "detailsData",
    // "autherList",
    // "periodiID",
  ],
  mounted() {
    // this.getPublisherInfo()
    // console.log('this.getPublisherInfo()');
  },
  watch: {
    detailsData: {
      handler() {
        this.getPublisherInfo();
        this.Getperiodical();
        this.getperiodiID();
        this.getAuthor();
        // console.log(this.periodicalInfo,'periodi12312calInfo');
      },
      deep: true,
      // immediate: true,
    },
  },
  computed: {
    allPage() {
      if (this.autherList.length) {
        return Math.ceil(this.autherList.length / 3);
      } else {
        return 0;
      }
    },
  },
  methods: {
    goBkOrBj() {
      if (this.detailsData.data.userType === 2) {
        let routeUrl = this.$router.resolve({
          path: `/jghdetail`,
          query: {
            title: "机构号",
            id: this.detailsData.data.companyId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/${
            this.detailsData.data.userType === 1 ? "bkzxdetail" : "bjzxdetail"
          }`,
          query: {
            title:
              this.detailsData.data.userType === 1 ? "百科在线" : "百家在线",
            id:
              this.detailsData.data.userType === 1
                ? this.detailsData.data.companyId
                : this.detailsData.data.createUser,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    goto(item) {
      let routeUrl = this.$router.resolve(
        {
          path: "/bjzxdetail",
          query: {
            title: "百家在线",
            id: item.userId,
          },
        }
        // `/bjzxdetail?title=百家在线&id=${item.userId}`
      );
      window.open(routeUrl.href, "_blank");
    },
    goBk() {
      // console.log(this.periodicalInfo.id);
      let routeUrl = this.$router.resolve(
        {
          path: "/bkzxdetail",
          query: {
            title: "百科在线",
            id: this.periodicalInfo.id,
          },
        }
        // `/bkzxdetail/bkzxmain?title=百科在线&id=${this.periodicalInfo.id}`
      );
      window.open(routeUrl.href, "_blank");
    },
    async getAuthor() {
      let userobj = {
        type: this.detailsData.data.userType,
      };
      if (this.detailsData.data.userType == 0) {
        userobj["userId"] = this.detailsData.data.createUser;
      } else {
        userobj["companyId"] = this.detailsData.data.companyId;
      }
      const res = await this.$apis.recomendServe.getAuthor(userobj);
      this.autherInfo = res.content;
      let othorAuthorInfo = [];
      this.detailsData.data.articleAuthorList.forEach((item) => {
        othorAuthorInfo.push(item.authorId);
      });
      let aurtherObj = {
        communicationAuthorInfo: this.detailsData.data.communicationAuthorId,
        firstAuthorInfo: this.detailsData.data.firstAuthorId,
        othorAuthorInfo,
      };
      const result = await this.$apis.recomendServe.getAuthorList(aurtherObj);
      this.autherList = result.data.data.othorAuthorInfo;
      this.autherList.unshift(result.data.data.firstAuthorInfo);
      if (result.data.data.communicationAuthorInfo) {
        this.autherList.push(result.data.data.communicationAuthorInfo);
      }
      this.autherview = this.autherList.slice(0, 3);
    },
    setIndex(num) {
      this.index = num;
      this.autherview = this.autherList.slice(num * 3, num * 3 + 3);
    },
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.data.periodicalId,
      };
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
    },
    async Getperiodical() {
      let obj = {
        type: this.detailsData.data.userType,
        // userId: this.detailsData.data.createUser,
        companyId: this.detailsData.data.periodicalId,
      };
      // const res = await this.$apis.recomendServe.periodical(obj);
      const res = await this.$apis.recomendServe.getAuthor(obj);
      this.periodicalInfo = res.content;
    },
    async getPublisherInfo() {
      let PublisherObj = {
        companyId: this.detailsData.data.companyId
          ? this.detailsData.data.companyId
          : null,
        createUser: this.detailsData.data.createUser,
      };
      const res = await this.$apis.recomendServe.PublisherInfo(PublisherObj);
      this.timeData = res.data;
      // this.timeData={user:1}
    },
  },
  data() {
    return {
      index: 0,
      aerList: [],
      timeData: {
        informationCount: 0,
        thesisCount: 0,
      },
      periodicalInfo: {},
      periodiID: {},
      autherInfo: {},
      autherList: [],
      autherview: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.Publisher {
  width: 270px;
  height: 250px;
  padding-left: 25px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      // height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      white-space: nowrap; //不换行
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //变成...
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;
      margin-top: -5px;
      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}

.author {
  width: 270px;
  padding-left: 25px;
  padding-bottom: 25px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    //font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
    font-size: 14px;
  }

  .user {
    width: 220px;
    //background: pink;
    display: flex;
    //margin-left: 10px;
    align-items: center;
    justify-content: flex-start;
    margin-top: 30px;
  }

  .dian {
    width: 220px;
    //background: pink;
    display: flex;
    justify-content: center;

    span {
      display: block;
      width: 8px;
      margin-left: 3px;
      margin-right: 3px;
      margin-top: 27px;
      height: 5px;
      background: #cccccc;
      border-radius: 2px;
    }

    .act {
      background: #007fff;
    }
  }

  .userImg {
    //float: left;
    //background: pink;
    //margin: 0 auto;
    //margin-left: 5px;
    //margin-right: 5px;
    //display: flex;
    .img {
      //background: pink;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }

    .name {
      cursor: pointer;
      width: 70px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #263d78;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .shunxu {
      width: 70px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }
  }
}
</style>
